// extracted by mini-css-extract-plugin
export var wrapper = "backend-section-module--wrapper--s-Zvo";
export var learnMore = "backend-section-module--learn-more--Zi3J7";
export var videoPlayer = "backend-section-module--video-player--8c7bR";